<template>
  <div class="agent-action-box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose"
      :close-on-click-modal="false"
      class="el-dialogs"
    >
      <el-form ref="form" :model="params" :rules="rules" label-width="140px">
        <el-form-item v-if="type === 'add'" label="APP类型:" prop="app">
          <el-select
            v-model="params.app"
            size="small"
            clearable
            placeholder="请选择APP类型"
          >
            <el-option
              v-for="item in appTypes"
              :value="item.value"
              :label="item.label"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item v-if="type==='edit'" label="状态:" prop="status">
          <el-select v-model="params.status" size="small" clearable placeholder="请选择状态">
            <el-option v-for="item in statusList" :value="item.value" :label="item.label" :key="item.value"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="渠道号:" prop="channel">
          <el-input v-model="params.channel" size="small" disabled></el-input>
          <el-button
            type="primary"
            size="small"
            class="checked"
            @click="openDataSelector"
            >选择</el-button
          >
        </el-form-item>
        <!-- <el-form-item v-if="type==='add'" label="兑换码批次号:" prop="batchNum">
          <el-input v-model="params.batchNum" size="small" placeholder="请输入兑换码批次号"></el-input>
        </el-form-item> -->
        <el-form-item label="兑换码权限:" prop="authority">
          <el-select
            v-model="params.authority"
            size="small"
            clearable
            placeholder="请选择兑换码权限"
          >
            <el-option
              v-for="item in authorityList"
              :value="item.value"
              :label="item.label"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="可用次数:" prop="usableNum">
          <el-input
            v-model.number="params.usableNum"
            size="small"
            placeholder="请输入可用次数"
          ></el-input>
        </el-form-item>
        <el-form-item label="兑换量:" prop="reward">
          <el-input
            v-model.number="params.reward"
            size="small"
            placeholder="请输入兑换量(单位:天)"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="type === 'add'"
          label="兑换码生成数量:"
          prop="count"
        >
          <el-input
            v-model.number="params.count"
            size="small"
            placeholder="请输入兑换码成数量"
          ></el-input>
        </el-form-item>
        <el-form-item label="生效时间:" prop="effectiveAt">
          <el-date-picker
            v-model="params.effectiveAt"
            type="datetime"
            placeholder="请选择日期时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="失效时间:" prop="invalidAt">
          <el-date-picker
            v-model="params.invalidAt"
            type="datetime"
            placeholder="请选择日期时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="备注:" prop="remark">
          <el-input
            v-model="params.remark"
            type="textarea"
            rows="3"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button
          type="primary"
          @click="submitForm('form')"
          :loading="flag"
          size="small"
          >确 认</el-button
        >
      </div>
    </el-dialog>
    <!-- 单选渠道 -->
    <radio-channel
      v-if="type === 'edit'"
      ref="channelSelector"
      @onChange="getChannel"
    >
    </radio-channel>
    <!-- 单选渠道 -->
    <!-- 多选渠道 -->
    <multiple-channels
      v-else
      ref="channelSelector"
      @onChange="getChannel"
    ></multiple-channels>
    <!-- 多选渠道 -->
  </div>
</template>
<script>
import API from "@/api";
import local from "@/utils/localStroage.js";
import { changeTime } from "@/utils/global";
import RadioChannel from "@/components/radioChannel";
import MultipleChannels from "@/components/multipleChannels";
export default {
  data() {
    return {
      // 外层弹出框
      dialogVisible: false,
      // 弹窗标题
      title: "",
      // 提交按钮状态
      flag: false,
      // 内层弹窗表格加载状态
      loading: false,
      // 编辑id
      id: "",
      // 当前是编辑还是新增
      type: "",
      // 新增兑换码请求参数
      params: {
        app: "",
        channel: "",
        // batchNum: '',
        authority: "shortVideoVip",
        reward: "",
        usableNum: "",
        count: "",
        effectiveAt: "",
        invalidAt: "",
        remark: "",
        status,
      },
      appTypes: [
        { label: "XVideos2", value: "ysAppVideo" },
        { label: "91约炮", value: "pfAppVideo" },
        { label: "雷霆加速器", value: "ltAppVpn" },
      ],
      authorityList: [
        { label: "兑换VIP", value: "shortVideoVip" },
        { label: "3天永久VIP", value: "3dPermanentVip" },
      ],
      statusList: [
        { label: "已兑换", value: "used" },
        { label: "未使用", value: "unused" },
        { label: "已过期", value: "expired" },
      ],
      /// 选择兑换码类型ID参数
      // idList: [],
      // params1: {
      //   type: '',
      //   crowdType: '',
      //   isActive: '',
      //   pageNumber: 1,
      //   pageSize: 10,
      // },
      // 验证规则
      rules: {
        app: [{ required: true, message: "请选择APP类型", trigger: "blur" }],
        // status: [
        //   { required: true, message: '请选择状态', trigger: 'blur' }
        // ],
        authority: [
          { required: true, message: "请选择兑换权限", trigger: "blur" },
        ],
        usableNum: [
          { required: true, message: "请输入可用次数", trigger: "blur" },
        ],
        reward: [{ required: true, message: "请输入兑换量", trigger: "blur" }],
        effectiveAt: [
          { required: true, message: "请选择生效时间", trigger: "blur" },
        ],
        invalidAt: [{ required: true, message: "请失效时间", trigger: "blur" }],
        // batchNum: [
        //   { required: true, message: '请输入批次号', trigger: 'blur' }
        // ],
        // channel: [
        //   { required: true, message: '请选择渠道', trigger: 'change' }
        // ],
        count: [
          { required: true, message: "请输入兑换码生成数量", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    /// 判断是否为超级管理员用户,只有超级管理员用户才能添加兑换金币选项
    const userInfo = local.get("userInfo"),
      role = userInfo.admin.role || "";
    if (role !== "superAdmin") {
      this.authorityList = [{ label: "兑换VIP", value: "shortVideoVip" }];
    }
  },
  components: {
    RadioChannel,
    MultipleChannels,
  },
  methods: {
    getChannel(val) {
      this.params.channel = val;
    },
    openDataSelector() {
      const val = this.params.channel;
      this.$refs.channelSelector.open(val);
    },
    // // 请求兑换码类型列表参数
    // redemptionTypeList() {
    //   API.redemptionTypeList(this.params1).then(res => {
    //     if (res.code === 200 && res.data.list) {
    //       this.idList = res.data.list
    //     } else {
    //       this.idList = []
    //     }
    //   }).catch(() => {
    //     this.idList = []
    //   })
    // },
    // 数据提交验证
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true;
          if (this.type === "add") {
            this.addCode();
          } else if (this.type === "edit") {
            this.editCode();
          }
        } else {
          return false;
        }
      });
    },
    // 新增兑换码
    addCode() {
      let params = Object.assign({}, this.params);
      params.channels = this.params.channel.split(",").slice(0, -1);
      delete params.channel;
      params.effectiveAt = changeTime(this.params.effectiveAt) || "";
      params.invalidAt = changeTime(this.params.invalidAt) || "";
      API.addCode(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "新增成功！",
              type: "success",
            });
            this.$emit("handlerCodeList");
          } else {
            if (res.tip) {
              this.$message.error(this.tip);
            } else {
              this.$message.error("新增失败！");
            }
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.flag = false;
          this.handleClose();
        });
    },
    // 修改兑换码
    editCode() {
      let params = Object.assign({}, this.params, { id: this.id });
      params.effectiveAt = changeTime(this.params.effectiveAt) || "";
      params.invalidAt = changeTime(this.params.invalidAt) || "";
      API.editCode(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "修改成功！",
              type: "success",
            });
            this.$emit("handlerCodeList");
          } else {
            if (res.tip) {
              this.$message.error(this.tip);
            } else {
              this.$message.error("修改失败！");
            }
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.flag = false;
          this.handleClose();
        });
    },

    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.params = {
        app: "",
        channel: "",
        // batchNum: '',
        authority: "",
        reward: "",
        usableNum: "",
        count: "",
        effectiveAt: "",
        invalidAt: "",
        remark: "",
        status: "",
      };
      this.$refs.form.resetFields();
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(type, data) {
      this.dialogVisible = true;
      // 请求兑换码类型id列表
      // this.redemptionTypeList()
      if (type === "add") {
        this.type = "add";
        this.title = "新增兑换码";
      } else {
        this.type = "edit";
        this.title = "修改兑换码";
        this.id = data.id;
        this.params = {
          app: data.app,
          channel: data.channel,
          // batchNum: data.batchNum,
          authority: data.authority,
          reward: data.reward,
          usableNum: data.usableNum,
          count: data.count,
          effectiveAt: data.effectiveAt.slice(0, 19),
          invalidAt: data.invalidAt.slice(0, 19),
          remark: data.remark,
          // status: data.status
        };
      }
    },
  },
};
</script>

<style lang="scss">
agent-action-box {
  .checked {
    margin-left: 10px;
  }
}
</style>
